import {
    getData,
} from './Services'

export const getSubrubros = async () => {
    const res = await getData('/subrubros/subrubros_select');
    return res
}

